import { StyledEngineProvider } from "@mui/material";
import { StrictMode } from "react";
import * as ReactDOM from "react-dom/client";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";

import App from "./App";
import { listenForStaleBuild } from "./lib/stale-build";
import reportWebVitals from "./reportWebVitals";
import { persister, store } from "./store";
import AppTheme from "./theme/AppTheme";

listenForStaleBuild();

ReactDOM.createRoot(document.querySelector("#root")!).render(
  <StrictMode>
    <StyledEngineProvider injectFirst>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persister}>
          <AppTheme>
            <App />
          </AppTheme>
        </PersistGate>
      </Provider>
    </StyledEngineProvider>
  </StrictMode>,
);

reportWebVitals();
